export default async function fetchTerritoryData(car) {
  const url = `https://api.agrotools.com.br/functions/car/consult_territory_by_code/${car}?IAMKEY=B0A1C8F78547A12FE164672D5C3FCD5CFE0C216E8EC920B28739ECC78EA414F7`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Erro na requisição');
    }

    const data = await response.json();
    return data.objectResult;
  } catch (error) {
    console.error('Erro:', error);
    throw error;
  }
}
